module.exports = __webpack_public_path__ + "static/media/anon-char.a47750c0.png";